import { useEffect, useState } from "react";
import { useAppUpdate } from "../hooks/useAppUpdate";

// Update prompt — a slim antique-gold bar pinned above every screen
// when a new deploy is installed and waiting (see useAppUpdate).
// Tapping ANYWHERE on the bar applies the update; the × dismisses it
// for this session only. When the app next returns to the foreground
// with the update still pending, the banner comes back — dismissal is
// "not now", never "never".
export function UpdateBanner() {
  const { updateAvailable, applyUpdate } = useAppUpdate();
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const onVisible = () => {
      if (document.visibilityState === "visible") setDismissed(false);
    };
    document.addEventListener("visibilitychange", onVisible);
    return () => document.removeEventListener("visibilitychange", onVisible);
  }, []);

  if (!updateAvailable || dismissed) return null;

  return (
    <div
      role="button"
      tabIndex={0}
      aria-label="New version available — tap to update"
      onClick={applyUpdate}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") applyUpdate();
      }}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 10000,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 10,
        padding: "calc(env(safe-area-inset-top, 0px) + 10px) 44px 10px 16px",
        background: "#9E8456",
        color: "#F2EDE3",
        fontFamily: "'DM Sans', sans-serif",
        fontSize: 13,
        fontWeight: 500,
        letterSpacing: "0.02em",
        cursor: "pointer",
        boxShadow: "0 2px 12px rgba(28,24,20,0.18)",
      }}
    >
      New version available — tap to update
      <button
        aria-label="Dismiss update banner"
        onClick={(e) => {
          e.stopPropagation();
          setDismissed(true);
        }}
        style={{
          position: "absolute",
          right: 8,
          top: "calc(env(safe-area-inset-top, 0px) + 4px)",
          bottom: 4,
          width: 32,
          border: "none",
          background: "transparent",
          color: "#F2EDE3",
          opacity: 0.75,
          fontSize: 16,
          lineHeight: 1,
          cursor: "pointer",
        }}
      >
        ×
      </button>
    </div>
  );
}
